<template>
  <div class="voice">
    <div class="voice__demo">
      <h1 class="voice__demo--h1">جزييات بیشتر از محصول</h1>
    </div>
    <div class="voice__filters"></div>
    <div class="voice__items">
      <div class="voice__items--container">
        <div class="voice__items--container-record">
          <aplayer
            autoplay
            :music="{
              artist: 'reza pishro',
              title: ' ',
              url:
                'https://dl.mokhtalefmusic.com/music/1396/12/29/Reza%20Pishro%20-%20Niloofare%20Abi%20%28New%20Version%29.mp3',
              cover:
                'https://lastfm.freetls.fastly.net/i/u/ar0/718e23e8e1d612a5ee10b105b2c12b35.jpg',
              theme: '#ef3954'
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Aplayer from "vue-aplayer";

export default {
  components: {
    Aplayer
  },
  data() {
    return {
      sentences: ""
    };
  },
  methods: {},
  created() {
    var that = this;
    that.$store.state.load = true;
    String.prototype.toPersianDigits = function() {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function(w) {
        return id[+w];
      });
    };
    $.ajax({
      url: that.$store.state.url + "api/v1/pages/extra_page/terms/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      type: "GET",
      success: function(data, textStatus, request) {
        that.sentences = data;
      },
      error: function(request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function() {
        that.$store.state.load = false;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
// @import "~pretty-checkbox/src/pretty-checkbox.scss";

.voice {
  width: 100%;
  min-height: auto;
  // background: red;
  margin-top: 8em;
  display: flex;
  flex-wrap: wrap;
  // flex-direction: row-reverse;
  @media screen and (max-width: 500px) {
  }
  &__demo {
    width: 100%;
    // background: var(--sub-color);
    background-image: linear-gradient(to right top, #f04d58d8, #f04d58),
      url("../../assets/photo/11.jpg");
    background-attachment: fixed;
    background-position: center center;
    background-size: cover;
    z-index: -1;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -0.5em;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.24);
    &--h1 {
      color: var(--sub-color);
      background: var(--main-color);
      padding: 0.25em 1em;
      border-radius: 10px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.24);
      @media screen and (max-width: 800px) {
        font-size: 1.7em;
      }
      @media screen and (max-width: 400px) {
        font-size: 1.5em;
      }
    }
  }
  &__items {
    direction: rtl;
    width: 100%;
    &--container {
      width: 98%;
      height: auto;
      background: var(--main-color);
      border: 1px solid #ebe9e9;
      position: relative;
      margin-right: auto;
      margin-left: auto;
      z-index: 2;
      overflow: hidden;
      margin-top: 2em;
      padding: 2em;
      display: flex;
      flex-direction: column;
    }
  }
}
.aplayer-icon {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/voice/voice.vue